import * as React from "react";

import { assertNever } from "@impero-com/common/utils/obj";
import { Svg } from "@impero-com/ui";

import LocalNode from "img/local-node.svg";

import * as theme from "../content/theme.css";
import * as T from "../content/types";
import { getScope } from "../content/utils";

class NameColumn extends React.PureComponent<NameColumnProps> {
    render = () => {
        const { node, children } = this.props;
        const scope = getScope(node).scope;
        switch (scope) {
            case "Global":
                return children;
            case "Local":
                return (
                    <div className={theme.localNode}>
                        {children}
                        <Svg src={LocalNode} />
                    </div>
                );
            default:
                assertNever(scope);
        }
    };
}

interface NameColumnProps {
    node: T.AnyNode;
    children?: React.ReactNode;
}

export { NameColumn, type NameColumnProps };
